const LANGUAGE_COOKIE_NAME = "ah_language";
const LANGUAGE_COOKIE_EXPIRATION = 7;

export { LANGUAGE_COOKIE_NAME, LANGUAGE_COOKIE_EXPIRATION };
